<div class="sidebar-container">
  <div class="logo">
    <h3>CCS Module</h3>
  </div>
  
  <nav class="navigation">
    <ul class="nav-list">
      <li *ngFor="let item of navItems" class="nav-item" [class.active]="item.isActive">
        <div class="nav-item-header" (click)="toggleNavItem(item)">
          <span class="nav-label">{{ item.label }}</span>
          <span class="arrow" *ngIf="item.children && item.children.length">
            <i [class.rotated]="item.isActive">▼</i>
          </span>
        </div>
        
        <ul class="sub-nav" *ngIf="item.children && item.children.length && item.isActive">
          <li *ngFor="let child of item.children" class="sub-nav-item"
              (click)="selectNavItem(item, child)">
            {{ child.label }}
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</div>
